import script from "./DirectiveCodeAssigner.vue?vue&type=script&setup=true&lang=js"
export * from "./DirectiveCodeAssigner.vue?vue&type=script&setup=true&lang=js"

import "./DirectiveCodeAssigner.vue?vue&type=style&index=0&id=51d69ede&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51d69ede"]])

export default __exports__